export function deletar(fetch, id) {
  return fetch().delete("/usuario/" + id);
}

export function getAll(fetch) {
  return fetch().get("/usuario");
}

export function getDetalhe(fetch, id) {
  return fetch().get("/usuario/" + id);
}

export function put(fetch, loja) {
  return fetch().put("/usuario", loja);
}
export function post(fetch, loja) {
  if (loja.modelo === "loja") {
    loja.gruposSelecionados = [];
    loja.fabricantesSelecionados = [];
    loja.setoresSelecionados = [];
  }

  return fetch().post("/usuario", loja);
}
